import React from 'react'
import PropTypes from 'prop-types'
import { differenceInDays } from 'date-fns'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { formatDate, LOCAL_DATE_FORMAT } from 'utils/date'

import LabelledValue from 'components/atoms/LabelledValue'
import TitleWithLabel from 'components/atoms/TitleWithLabel'
import TablePreloader from 'components/atoms/TablePreloader'
// import TimeBlockSelector from 'components/molecules/TimeBlockSelector'
import {
  BatteryFullIcon,
  BatteryMediumIcon,
  BatteryLowIcon,
  BatteryCriticalIcon,
} from 'assets/SVGIcons'

const styles = theme => ({
  root: {
    minWidth: 700,
    padding: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dataSyncedLabel: {
    marginTop: theme.spacing(2),
  },
  timeInput: {
    margin: `${theme.spacing(4)}px 0`,
  },
  killLabel: {
    paddingRight: 0,
  },
  inactiveChart: {
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.background.medium}`,
  },
  // graphPlaceholder: {
  //   height: 40,
  //   padding: 14,
  //   fontSize: 13,
  //   width: '100%',
  //   textAlign: 'center',
  //   color: theme.palette.white,
  //   margin: `${theme.spacing(4)}px 0`,
  //   backgroundColor: theme.palette.tertiary.main
  // },
  trapStats: {
    width: 400,
    display: 'flex',
    paddingTop: theme.spacing(2),
    justifyContent: 'space-between',
  },
  battery: {
    transform: 'translateY(6px)',
    marginRight: theme.spacing(1),
  },
  serial: {
    fontSize: 22,
    fontWeight: 700,
  },
})

const renderBatteryLevel = (classes, batteryLevel) => {
    let value
    let icon

    if (batteryLevel === undefined) {
        value = '???'
        icon = null
    }
    else if (batteryLevel < 56) {
        value = 'Full'
        icon = BatteryFullIcon
    }
    else if (batteryLevel < 200) {
        value = 'Medium'
        icon = BatteryMediumIcon
    }
    else if (batteryLevel < 230) {
        value = 'Low'
        icon = BatteryLowIcon
    }
    else {
        value = 'Critical'
        icon = BatteryCriticalIcon
    }

  return (
    <LabelledValue
      value={value}
      labelIcon={icon}
      label="Battery life"
      labelClassname={classes.battery}
    />
  )
}

const TrapDetailsPopover = ({
  // data,
  trap,
  classes,
  // timeValue,
  // onTimeChange,
}) => (
  <div className={classes.root}>
    {trap ? (
      <React.Fragment>
        <section className={classes.header}>
          <div>
              <Typography
                  variant="h1"
                  className={!trap.trapName ? classes.serial : null}>
                  {trap.trapName || trap.serial}
              </Typography>
              <Typography className={classes.dataSyncedLabel}>
                  Data last collected{' '}
                  {trap.lastSynced
                      ? formatDate(trap.lastSynced, LOCAL_DATE_FORMAT)
                      : '-'}
              </Typography>
          </div>
          <TitleWithLabel
              classes={{root: classes.killLabel}}
              title={trap.totalKills}
              label="Total kills"
          />
        </section>
        {/* <section className={classes.inactiveChart}>
          <TimeBlockSelector 
            value={timeValue} 
            onChange={onTimeChange} 
            className={classes.timeInput} 
            label="Inactive days breakdown" 
          />
          <div className={classes.graphPlaceholder}>I am a placeholder</div>
        </section> */}
        <section className={classes.trapStats}>
          {renderBatteryLevel(classes, trap.batteryLevel)}
            <LabelledValue label="CO2" value={`${trap.strikesLeft}/24`}/>
            <LabelledValue
                label="Paste"
                value={`${trap.lureDaysLeft} days`}
            />
        </section>
      </React.Fragment>
    ) : (
      <TablePreloader />
    )}
  </div>
)

TrapDetailsPopover.propTypes = {
  // data: PropTypes.object,
  trap: PropTypes.object,
  classes: PropTypes.object,
  // timeValue: PropTypes.string,
  // onTimeChange: PropTypes.func,
}

export default withStyles(styles)(TrapDetailsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/TrapDetailsPopover/TrapDetailsPopover.js